import { render, staticRenderFns } from "./ExternalCampaignsTable.vue?vue&type=template&id=4627c393&"
import script from "./ExternalCampaignsTable.vue?vue&type=script&lang=ts&"
export * from "./ExternalCampaignsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTd}, component.options.components || {})
